// extracted by mini-css-extract-plugin
module.exports = {"adress":"styles_adress__wlvHw","scrollbars":"styles_scrollbars__bj_wb","title":"styles_title__wDHHb","slideInSearchBar":"styles_slideInSearchBar__E3bBQ"};